import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DropDown from '@components/DropDown/DropDown';
import { DropDownOptionType } from '@components/DropDown/Option';
import './layers-time-selectors.scss';
import { useTypedSelector } from '@redux/Hooks/storeSelectors';
import { selectProjectDateTypes } from '@redux/selectors/selectors';
import { DateType } from '@redux/map/types';
import { selectedDateType } from '@redux/map/map-reducer';
import { useTheme } from '@context/themeContext';
import { themeColors } from '@styles/theme';
import { CheckIcon } from '@components/icons/icons/CheckIcon';

const LayersTimeSelectors = () => {
    const [periodMode, setPeriodMode] = useState<string>('');
    const dateTypesByIds = useTypedSelector(selectProjectDateTypes);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { theme } = useTheme();

    useEffect(() => {
        const dateTypesById = Object.entries(dateTypesByIds);
        if (dateTypesById.length) {
            const [id, dateType] = dateTypesById[0];
            setPeriodMode(dateType.name);
            dispatch(selectedDateType(id));
        }
    }, [dateTypesByIds, dispatch]);

    const selectPeriod = (id: string, dateType: DateType) => {
        setPeriodMode(dateType.name);
        dispatch(selectedDateType(id));
    };

    const options = useMemo((): DropDownOptionType[] => {
        return Object.entries(dateTypesByIds).map(([id, dateType]) => ({
            title: dateType.name,
            onClick: () => selectPeriod(id, dateType),
            image:
                periodMode === dateType.name ? (
                    <CheckIcon
                        color={theme === 'light' ? themeColors.navyBlue : themeColors.white}
                    />
                ) : null,
        }));
    }, [dateTypesByIds, theme]);

    return (
        <>
            {options.length ? (
                <div className={`layers-time-selectors-wrapper`}>
                    <DropDown
                        title={
                            <>
                                <span className="time-period-label">
                                    {t('layers-list.period')}:
                                </span>
                                <span className="time-period">{periodMode}</span>
                            </>
                        }
                        titleColorLight={themeColors.navyBlue}
                        titleColorDark={themeColors.white}
                        options={options}
                        iconColorLight={themeColors.navyBlue}
                        iconColorDark={themeColors.white}
                        outlined={false}
                    />
                </div>
            ) : null}
        </>
    );
};

export default LayersTimeSelectors;
